export default "__VITE_ASSET__CNbr4wWi__"